import React, { useState } from 'react';
import { Package } from 'lucide-react';
import './index.css';
import ConfirmDialog from '../ConfirmDialog';

const BundleServiceResume = (props) => {
  const { onRemove, serviceTitle, bundleTitle, colorStyle } = props;

  const [dialog, setDialog] = useState(false)

  return (
    <>
      <div className={`service-resume ${colorStyle || ""}`}>
        <Package />
        <div>
          <h3>{serviceTitle}</h3>
          <p>
            Servizio già incluso nell’offerta che hai selezionato:{" "}
            {bundleTitle}
          </p>
        </div>

        <button 
          onClick={() => {
            setDialog(true);
            document.body.style.overflow = "hidden";
          }}
        >
          Modifica
        </button>
      </div>
      {dialog && (
        <ConfirmDialog
          title={bundleTitle}
          onConfirm={() => {
            onRemove();
            setDialog(false);
            document.body.style.overflow = "auto";
          }}
          onClose={() => {
            setDialog(false);
            document.body.style.overflow = "auto";
          }}
        />
      )}
    </>
  )
};

export default BundleServiceResume;